import bowser from 'bowser';

const BOWSER_FLAG_NAMES = [
  // device
  'mobile', 'tablet',
  // browser
  'chrome', 'firefox', 'msie', 'msedge', 'safari', 'opera', 'samsungBrowser', 'phantom',
  // os
  'mac', 'windows', 'windowsphone', 'android', 'ios', 'chromeos', 'linux',
];

export const LOGGLY_KEY = '5b463cad-fa33-415e-b10f-3ded0c4bd034';

export function getLogglyTags() {
  const logglyTags = ['prod', 'voltron-ui'];

  // attach browser, os, and device tags to our log messages
  BOWSER_FLAG_NAMES.forEach(flagName => {
    if (bowser[flagName]) {
      logglyTags.push(flagName);
    }
  });

  return logglyTags;
}



// WEBPACK FOOTER //
// ./src/config/loggly.js